import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckSquare, Star, FileText, User } from "lucide-react";

export const CandidateTabs = () => {
  const { t } = useTranslation();
  const tabs = [
    { to: "/candidate/applications", icon: CheckSquare, label: t("dashboard.myApplications") },
    { to: "/candidate/saved", icon: Star, label: t("dashboard.savedJobs") },
    { to: "/candidate/request", icon: FileText, label: t("dashboard.myRequest") },
    { to: "/candidate/profile", icon: User, label: t("dashboard.myProfile") },
  ];
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar mb-6 border-b border-stone-border" data-testid="candidate-tabs">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            data-testid={`ctab-${tab.to.split("/").pop()}`}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${
                isActive ? "border-brand text-brand" : "border-transparent text-stone-sub hover:text-brand"
              }`
            }
          >
            <Icon className="w-4 h-4" /> {tab.label}
          </NavLink>
        );
      })}
    </div>
  );
};
